import React, { useEffect, useState } from 'react'
import DataTable from "react-data-table-component";

import user_Store from '../store/user_store'
import student_Store from '../store/student_store'
import supervisor_Store from '../store/supervisor_store'
import admin_Store from '../store/admin_store'
import ExportCSV from '../functions/ExportCSV';
import Selector_Component from '../component/Selector_Component';
import CurrUser from '../functions/UserAuth'

function Admin_Page() {
  
  // Student Store
  const student = student_Store((state) => state.student)
  // Supervisor Store
  const supervisor = supervisor_Store((state) => state.supervisor)
  // Admin Store
  const admin = admin_Store((state) => state.admin)
  
  const admins = admin_Store((state) => state.admins)
  const getadmins = admin_Store((state) => state.getadmins)
  const putadmin = admin_Store((state) => state.putadmin)
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const currentUser= CurrUser(student, supervisor, admin)
  
  //  let [selectValue, setSelectValue]= useState([])
  function onSelect(actionId, id, setStatus, setClasss) {
    setStatus(actionId)
    let classvalue = actionId == 'Activated' ? 'success' : actionId == 'Deactivated' ? 'danger' : 'warning'
    setClasss(classvalue)
    putadmin({ status: actionId }, id, currentUser?.token)
    //   setClasss(classvalue)
  }
  
  const columns = [
    {
      name: "ID",
      selector: (row,index) => index+1,
      sortable: true,
      width: '400px',
      id: 1,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      id: 2,
    },
    {
      name: "name",
      selector: (row) => row.name,
      id: 3,
    },
  ];
  let [mydata, setMydata] = useState([])
  
  useEffect(() => {
    getadmins()
  }, [])
  
  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
  };
  
  const handlePageChange = (page) => {
    setPage(page);
  };
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
  
  
  function onChange(e) {
    let word = e.target.value
    const result = admins.data.filter(admin => admin.name && admin.name.toLowerCase().includes(word.toLowerCase()) || admin.email.includes(word) || admin?.id == word)
    setMydata(result)
    if (word === '') {
      setMydata([])
      setResetPaginationToggle(!resetPaginationToggle);
    }
  }
  
  function exportTable() {
    let arr = mydata.length > 0 ? mydata : admins.data
    arr.forEach((obj,index) => obj.id=index+1)
    arr.forEach((obj) => obj.created_at= (new Date(obj?.created_at ?? '')?.toLocaleString()?.replace(',', '-') ?? '') )
    arr.forEach((obj) => delete obj.image)
    arr.forEach((obj) => delete obj.roles)
    ExportCSV(arr,'admins')
  }
  
  return (
    <>
       <div className='d-flex bd-highlight'>
        <div className='pt-2 flex-grow-1 bd-highlight'>
          <input
            type='text'
            onChange={(e) => onChange(e)}
            className='form-control w-50'
            placeholder='Search..'
            required
            aria-label=''
            aria-describedby='basic-addon1'
          />
        </div>
       
        <div className='p-2 bd-highlight'>
          <button
            onClick={function () {
              exportTable()
            }}
            className='btn   btn-md btn btn-outline-primary'
            type='button'
          >
            CSV
          </button>
        </div>
      </div>


      <DataTable
        title="Admins"
        columns={columns}
        data={mydata?.length > 0 ? mydata : admins.data}
        progressPending={false}
        pagination
        paginationResetDefaultPage={resetPaginationToggle}
        paginationTotalRows={mydata?.length > 0 ? mydata?.length : admins?.data?.length}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        pointerOnHover
        highlightOnHover
      />
    </>
  )
};

export default Admin_Page
